import axios from 'axios'

const instance = axios.create({
  baseURL: "http://localhost",
  headers: {
    'Access-Control-Allow-Origin': "*"
  },
  timeout: 10000, // 设置超时时间
})

export const getImageUrl = data => instance.post('/dashboard/bin', data)

// 请求拦截器
// instance.interceptors.request.use((config) => {
//   const token = localStorage.getItem('token')
//   if (token) {
//     config.headers.authorization = token
//   }
//   return config
// }, (error) => {
//   return Promise.reject(error)
// })

// // 定义拦截器 请求拦截器 和 响应拦截器
// instance.interceptors.response.use((response) => {
//   if (response.data.code === 200) {
//     // 请求成功 方便我们获取请求到的数据 不需要再res.data.data
//     console.log(response)
//     if (response.headers['x-total-count']) {
//       return {
//         data: response.data.data,
//         total: +response.headers['x-total-count']
//       }
//     } else {
//       return response.data.data

//     }

//   } else {
//     return Promise.reject(response.data.msg)
//   }
//   // return response
// }, (error) => {
//   // console.log([error])
//   // // 判断错误代码是不是401
//   // if (error.response.status === 401) {
//   //   Message.error("token失效")
//   //   // 跳转到登录
//   //   router.push('/login')
//   // }
//   return Promise.reject(error)
// })
